enum MapColors {
  Forbidden = 0,
  Allowed = 254,
  Unknown = 205,
}

export default MapColors;
